import { commonTypes } from '../common';

export const types = {

};

export const initialState = {
  accountInfo: null,
};

const ApisNeedsAccountReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_ACCOUNT_INFO: {
      const { customerAccountId, customerAccountNumber } = action.payload;

      if (customerAccountId) {
        return {
          ...state,
          accountInfo: {
            customerAccountId,
          },
        };
      }
      if (customerAccountNumber) {
        return {
          ...state,
          accountInfo: {
            customerAccountNumber,
          },
        };
      }

      return { ...state };
    }
    default:
      return null;
  }
};

export const actions = {

};

export default ApisNeedsAccountReducer;
